/* Couleur Safran — comportements légers des sections (vanilla, aucune librairie).
 * Famille de parfums, villes Riviera, guides, curseur d'intensité, quiz, comparateur,
 * ajout rapide au panier et actions « choisir ce parfum » vers le sélecteur de la fiche produit.
 */
(function () {
  if (window.__csUI) return;
  window.__csUI = true;

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = function () { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; };

  /* ---------- panier Kalles ---------- */
  function refreshAndOpenCart() {
    try { if (window.T4SThemeSP && T4SThemeSP.Cart && T4SThemeSP.Cart.getToFetch) T4SThemeSP.Cart.getToFetch(); } catch (e) { /* noop */ }
    setTimeout(function () {
      var t = $('a[data-drawer-options*="t4s-mini_cart"]');
      if (t) t.click(); else location.href = root() + 'cart';
    }, 350);
  }
  function quickAdd(btn) {
    var id = btn.dataset.csAdd; if (!id) return;
    var label = btn.textContent; btn.disabled = true; btn.textContent = '…';
    fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Erreur'); }); })
      .then(function () { btn.textContent = 'Ajouté ✓'; refreshAndOpenCart(); setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2200); })
      .catch(function (e) { btn.textContent = e.message || 'Erreur'; setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2600); });
  }

  /* ---------- clics délégués ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cs-add],[data-cs-pick]:not([data-cs-pick=""]),[data-cs-family],[data-cs-city-pick],[data-cs-mode],[data-cs-scroll]');
    if (!t) return;
    if (t.matches('[data-cs-add]')) { e.preventDefault(); return quickAdd(t); }
    if (t.matches('[data-cs-pick],[data-cs-family],[data-cs-city-pick],[data-cs-mode]')) {
      if (!$('cs-product')) return; // pas de fiche sur cette page : le lien href fait son travail
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('cs:pick', { detail: {
        scent: t.dataset.csPick, family: t.dataset.csFamily, city: t.dataset.csCityPick, mode: t.dataset.csMode
      } }));
      return;
    }
    if (t.matches('[data-cs-scroll]')) {
      var tg = $(t.dataset.csScroll); if (tg) { e.preventDefault(); window.scrollTo({ top: tg.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' }); }
    }
  });

  /* ---------- explorateur de familles (homepage) ---------- */
  function initFam(host) {
    var tabs = $$('[role=tab]', host), panels = $$('[data-fam-panel]', host);
    function show(i) {
      tabs.forEach(function (b, k) { b.setAttribute('aria-selected', String(k === i)); });
      panels.forEach(function (p, k) { p.hidden = k !== i; });
      var first = $('[data-frag]', panels[i]); if (first) frag(panels[i], first);
    }
    function frag(panel, item) {
      $$('[data-frag]', panel).forEach(function (x) { x.classList.toggle('is-on', x === item); });
      var field = $('[data-field]', panel); if (!field) return;
      field.style.setProperty('--cs-tone', item.dataset.color || '#EDE3D3');
      $('[data-field-n]', field).textContent = item.dataset.name;
      $('[data-field-e]', field).textContent = item.dataset.echo || '';
    }
    tabs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    panels.forEach(function (p) {
      $$('[data-frag]', p).forEach(function (it) {
        it.addEventListener('mouseenter', function () { frag(p, it); });
        it.addEventListener('focus', function () { frag(p, it); });
      });
    });
    function equalize() {
      host.style.removeProperty('--fam-left');
      if (window.innerWidth < 900) return;
      var max = 0;
      panels.forEach(function (p) {
        var was = p.hidden; p.hidden = false;
        var c = p.querySelector(':scope > div:not(.cs-fam__field)');
        if (c) max = Math.max(max, c.getBoundingClientRect().height);
        p.hidden = was;
      });
      host.style.setProperty('--fam-left', Math.ceil(max) + 'px');
    }
    show(0);
    equalize();
    window.addEventListener('resize', equalize);
    window.addEventListener('load', equalize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalize);
  }

  /* ---------- villes Riviera (homepage) ---------- */
  function initRiv(host) {
    var items = $$('[data-city]', host), poster = $('[data-poster]', host), name = $('[data-poster-n]', host);
    function on(it) {
      items.forEach(function (x) { x.classList.toggle('is-on', x === it); });
      poster.style.setProperty('--cs-tone', it.dataset.tone || '#B5C6CC'); name.textContent = it.dataset.name;
      var any = false;
      $$('[data-poster-img]', poster).forEach(function (im) { var m = im.dataset.posterImg === it.dataset.name; im.hidden = !m; if (m) any = true; });
      var def = $('[data-poster-default]', poster); if (def) def.hidden = any;
    }
    items.forEach(function (it) { it.addEventListener('mouseenter', function () { on(it); }); it.addEventListener('click', function () { on(it); }); });
    if (items[0]) on(items[0]);
  }

  /* ---------- guide (pièces, intentions) ---------- */
  function initGuide(host) {
    var tabs = $$('.cs-tab', host), panels = $$('[data-guide-panel]', host);
    function show(i) { tabs.forEach(function (b, k) { b.setAttribute('aria-selected', String(k === i)); }); panels.forEach(function (p, k) { p.hidden = k !== i; }); }
    tabs.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
    function equalize() {
      host.style.removeProperty('--guide-h');
      if (window.innerWidth < 900) return;
      var max = 0;
      panels.forEach(function (p) { var was = p.hidden; p.hidden = false; max = Math.max(max, p.getBoundingClientRect().height); p.hidden = was; });
      host.style.setProperty('--guide-h', Math.ceil(max) + 'px');
    }
    show(0);
    equalize();
    window.addEventListener('resize', equalize);
    window.addEventListener('load', equalize);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalize);
  }

  /* ---------- curseur d'intensité ---------- */
  function initInten(host) {
    var r = $('input[type=range]', host), out = $('[data-inten-text]', host), lines = $$('[data-inten-line]', host).map(function (x) { return x.textContent; });
    var btns = $$('[data-inten-set]', host);
    function up() {
      var v = +r.value;
      out.textContent = lines[v] || '';
      host.style.setProperty('--p', (v * 50) + '%');
      btns.forEach(function (b) { b.classList.toggle('is-on', +b.dataset.intenSet === v); });
      if (window.CustomEvent) document.dispatchEvent(new CustomEvent('cs:intensity', { detail: v }));
    }
    r.addEventListener('input', up); r.addEventListener('change', up);
    btns.forEach(function (b) { b.addEventListener('click', function () { r.value = b.dataset.intenSet; up(); }); });
    up();
  }

  /* ---------- quiz ---------- */
  function initQuiz(host) {
    var qs = $$('[data-quiz-q]', host), res = $('[data-quiz-res]', host), top = +(host.dataset.top || 3), total = qs.length;
    var step = $('[data-quiz-step]', host), bar = $('[data-quiz-bar]', host), back = $('[data-quiz-back]', host), head = $('[data-quiz-top]', host);
    var hist = [], i = 0;
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function scores() {
      var sc = {};
      hist.forEach(function (tags) { tags.forEach(function (tg) { sc[tg] = (sc[tg] || 0) + 1; }); });
      return sc;
    }
    function show() {
      qs.forEach(function (q, k) { q.hidden = k !== i; });
      var done = i >= total;
      res.hidden = !done; if (head) head.hidden = done;
      if (!done) {
        if (step) step.textContent = pad(i + 1) + ' / ' + pad(total);
        if (bar) bar.style.width = ((i + 1) / total * 100) + '%';
        if (back) back.hidden = i === 0;
      } else finish();
    }
    function finish() {
      var sc = scores(), ranked = Object.keys(sc).sort(function (a, b) { return sc[b] - sc[a]; });
      var panels = $$('[data-quiz-result]', res);
      if (panels.length) {
        var win = null;
        ranked.some(function (tg) { return panels.some(function (p) { if (p.dataset.quizResult === tg) { win = p; return true; } return false; }); });
        panels.forEach(function (p) { p.hidden = p !== (win || panels[0]); });
      } else {
        var list = $('[data-quiz-list]', res);
        if (list) {
          list.innerHTML = '';
          ranked.slice(0, top).forEach(function (n) {
            var b = document.createElement('button');
            b.type = 'button'; b.className = 'cs-btn cs-btn--ghost'; b.textContent = n; b.dataset.csPick = n; list.appendChild(b);
          });
        }
      }
      document.dispatchEvent(new CustomEvent('cs:quiz-done', { detail: ranked.slice(0, top) }));
    }
    qs.forEach(function (q) {
      $$('[data-tags]', q).forEach(function (b) {
        b.addEventListener('click', function () {
          hist[i] = (b.dataset.tags || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
          i++; show();
        });
      });
    });
    if (back) back.addEventListener('click', function () { if (i > 0) { i--; hist.length = i; show(); } });
    $$('[data-quiz-restart]', host).forEach(function (r) { r.addEventListener('click', function () { hist = []; i = 0; show(); }); });
    show();
  }

  /* ---------- comparateur ---------- */
  function initCmp(host) {
    var heads = $$('th[scope=col] button', host);
    heads.forEach(function (b, k) {
      b.addEventListener('click', function () {
        $$('tr', host).forEach(function (tr) { tr.classList.remove('is-on'); });
        heads.forEach(function (h) { h.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
    });
  }

  /* ---------- vitrine éditoriale (versions d'un parfum) ---------- */
  function initShowcase(host) {
    var items = $$('[data-sc-item]', host), imgs = $$('[data-sc-img]', host), cnt = $('[data-sc-count]', host), n = items.length;
    var rom = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII'];
    function show(i) {
      items.forEach(function (x, k) { x.classList.toggle('is-on', k === i); $('.cs-sc__head', x).setAttribute('aria-expanded', String(k === i)); });
      imgs.forEach(function (x, k) { x.classList.toggle('is-on', k === i); });
      if (cnt) cnt.textContent = rom[i] + ' / ' + n;
    }
    items.forEach(function (it, i) {
      var h = $('.cs-sc__head', it);
      h.addEventListener('click', function () { show(i); });
      if (window.matchMedia('(hover:hover)').matches) h.addEventListener('mouseenter', function () { show(i); });
    });
  }

  /* pastilles de couleur des parfums : réutilise la table de couleurs de la fiche produit */
  var norm = function (s) { return String(s == null ? '' : s).toLowerCase().replace(/[’‘`´]/g, "'").normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/s+/g, ' ').trim(); };
  function paintDots() {
    var data = $('cs-product [data-cs-data]'); if (!data) return;
    var d; try { d = JSON.parse(data.textContent); } catch (e) { return; }
    var map = String(d.colors || '').split(/\r?\n/).map(function (l) { var i = l.lastIndexOf(':'); return [norm(l.slice(0, i)), l.slice(i + 1).trim()]; })
      .filter(function (x) { return x[0]; }).sort(function (a, b) { return b[0].length - a[0].length; });
    $$('[data-cs-dot]').forEach(function (el) {
      var n = norm(el.dataset.csDot), c = '', i;
      for (i = 0; i < map.length && !c; i++) if (n === map[i][0]) c = map[i][1];
      for (i = 0; i < map.length && !c; i++) if (n.indexOf(map[i][0]) > -1) c = map[i][1];
      el.style.setProperty('--c', c || '#D9CFC0');
    });
  }

  /* FAQ : une seule question ouverte à la fois (en plus de l'attribut name natif) */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var list = d.closest('.cs-faq__list'); if (!list) return;
    $$('details[open]', list).forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
  }, true);

  function once(sel, fn) { $$(sel).forEach(function (h) { if (h.__cs) return; h.__cs = true; fn(h); }); }
  function boot() {
    paintDots();
    once('[data-cs-fam]', initFam); once('[data-cs-riv]', initRiv); once('[data-cs-guide]', initGuide);
    once('[data-cs-inten]', initInten); once('[data-cs-showcase]', initShowcase); once('[data-cs-quiz]', initQuiz); once('[data-cs-cmp]', initCmp);
  }
  // avis clients : carrousel (flèches)
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rv-prev],[data-rv-next]');
    if (!b) return;
    var g = b.closest('.cs-rev').querySelector('[data-cs-rvgrid]'); if (!g) return;
    var c = g.querySelector('.cs-rv__card'); var step = c ? c.getBoundingClientRect().width + 20 : g.clientWidth;
    g.scrollBy({ left: (b.hasAttribute('data-rv-next') ? 1 : -1) * step, behavior: 'smooth' });
  });
  // avis clients : filtre Tous / Produit / Google
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-cs-rvtabs] button');
    if (!b) return;
    var box = b.closest('.cs-rev'), v = b.dataset.rv;
    box.querySelectorAll('[data-cs-rvtabs] button').forEach(function (x) { x.classList.toggle('is-on', x === b); });
    box.querySelectorAll('.cs-rv__card').forEach(function (c) { c.hidden = !(v === 'all' || c.dataset.source === v); });
  });
  // rangée de produits à défilement horizontal : flèches
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-rail-prev],[data-rail-next]');
    if (!b) return;
    var rail = b.closest('.cs-wrap').querySelector('[data-cs-rail]');
    if (!rail) return;
    var card = rail.querySelector('.cs-pcard');
    var step = card ? card.getBoundingClientRect().width + 20 : rail.clientWidth * 0.8;
    rail.scrollBy({ left: (b.hasAttribute('data-rail-next') ? 1 : -1) * step * 2, behavior: 'smooth' });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // éditeur de thème : réinitialiser quand une section est (re)chargée
  document.addEventListener('shopify:section:load', function () { boot(); });
})();
